import { categories } from './categories';

export interface Chapter {
  id: number;
  number: number;
  title: string;
  date: string;
  content: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  updateDate: string;
  chapters: Chapter[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '星光下的约定',
    author: '金秀雅',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20style%20illustration%20of%20a%20young%20couple%20under%20a%20starry%20night%20sky%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20delicate%20lineart%2C%20pastel%20color%20palette%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '在繁华的首尔街头，两个来自完全不同世界的年轻人因一次偶然的相遇而命运交织。星光见证他们的每一个约定，也照亮彼此心中最柔软的地方。这是一个关于成长、选择与真爱的温暖故事。',
    tags: ['纯爱', '都市', '青春', '治愈'],
    rating: 9.2,
    views: 1285000,
    status: '连载中',
    updateDate: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 101, number: 1, title: '意外的邂逅', date: '2026-06-15', content: '首尔的夜晚，霓虹灯光闪烁...' },
      { id: 102, number: 2, title: '星光下的秘密', date: '2026-06-22', content: '那一晚过后，她的生活彻底改变了...' },
      { id: 103, number: 3, title: '命运的交汇', date: '2026-06-29', content: '两条平行线，终于有了交点...' },
      { id: 104, number: 4, title: '心中的涟漪', date: '2026-07-06', content: '每次见到他，心跳都会加快...' },
      { id: 105, number: 5, title: '无法言说的感情', date: '2026-07-13', content: '她试图逃避，却发现越陷越深...' },
      { id: 106, number: 6, title: '勇敢的一步', date: '2026-07-20', content: '他终于鼓起勇气说了出来...' },
    ],
  },
  {
    id: 2,
    title: '暗影猎人',
    author: '李正勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20manhwa%20cover%20illustration%20of%20a%20mysterious%20hunter%20in%20black%20clothing%20holding%20a%20weapon%2C%20dramatic%20shadowy%20atmosphere%2C%20urban%20fantasy%20style%2C%20cool%20dark%20color%20tones%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-02&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '在普通人类看不见的世界里，有一群被称为"暗影猎人"的存在。他们守护着人类与怪物之间的平衡，以鲜血和牺牲捍卫着最后的防线。当古老的封印开始松动，新一代猎人必须挺身而出。',
    tags: ['热血', '战斗', '超能力', '悬疑'],
    rating: 9.5,
    views: 2560000,
    status: '连载中',
    updateDate: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 201, number: 1, title: '觉醒之日', date: '2026-05-10', content: '那是我十八岁生日那天发生的事情...' },
      { id: 202, number: 2, title: '第一次任务', date: '2026-05-17', content: '新人的第一场试炼即将开始...' },
      { id: 203, number: 3, title: '暗影中的敌人', date: '2026-05-24', content: '敌人就在身边，只是我们看不见...' },
      { id: 204, number: 4, title: '古老的封印', date: '2026-05-31', content: '封印正在以肉眼可见的速度崩坏...' },
      { id: 205, number: 5, title: '队友的背叛', date: '2026-06-07', content: '最信任的人，往往伤你最深...' },
    ],
  },
  {
    id: 3,
    title: '魔法学院的插班生',
    author: '朴智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Korean%20manhwa%20cover%20illustration%20of%20a%20young%20student%20in%20a%20magical%20academy%20uniform%20with%20floating%20spell%20effects%2C%20fantasy%20setting%2C%20bright%20magical%20atmosphere%2C%20warm%20golden%20lighting%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-03&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '平凡高中生韩智浩在收到一封神秘录取通知书后，来到了隐藏在世界缝隙中的魔法学院。在这里，他发现自己拥有着连最高阶法师都无法解释的奇异力量。魔法、友情与冒险，就此展开。',
    tags: ['魔法', '校园', '冒险', '成长'],
    rating: 9.1,
    views: 1890000,
    status: '连载中',
    updateDate: '2026-08-04',
    isHot: true,
    isNew: true,
    isRecommended: true,
    chapters: [
      { id: 301, number: 1, title: '神秘的信件', date: '2026-07-01', content: '一封盖着金色火漆的信件出现在我的书桌上...' },
      { id: 302, number: 2, title: '穿越之门', date: '2026-07-08', content: '穿过那扇门，世界变得完全不同...' },
      { id: 303, number: 3, title: '入学测试', date: '2026-07-15', content: '测试的内容远超我的想象...' },
      { id: 304, number: 4, title: '元素亲和力', date: '2026-07-22', content: '测试结果显示，我的元素亲和力是史无前例的...' },
    ],
  },
  {
    id: 4,
    title: '第七个目击者',
    author: '崔敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20Korean%20manhwa%20cover%20illustration%20of%20a%20person%20looking%20through%20a%20rain-soaked%20window%20at%20night%2C%20mysterious%20thriller%20atmosphere%2C%20dark%20blue%20and%20grey%20tones%2C%20tense%20mood%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '一起看似普通的交通事故，七个互不相识的目击者，七段截然不同的证词。刑警姜道贤在调查过程中发现，每个人都在说谎，而真相远比想象中更加黑暗。究竟谁才是真正的凶手？',
    tags: ['推理', '犯罪', '反转', '心理'],
    rating: 9.4,
    views: 3120000,
    status: '已完结',
    updateDate: '2026-07-20',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 401, number: 1, title: '雨夜的交通事故', date: '2026-03-01', content: '雨下得很大，能见度不到十米...' },
      { id: 402, number: 2, title: '第一个谎言', date: '2026-03-08', content: '每一位目击者的证词都有微妙的差异...' },
      { id: 403, number: 3, title: '消失的物证', date: '2026-03-15', content: '关键的物证在警察局里不翼而飞...' },
      { id: 404, number: 4, title: '第四个人的秘密', date: '2026-03-22', content: '他隐藏的东西比谋杀更可怕...' },
      { id: 405, number: 5, title: '真相浮现', date: '2026-03-29', content: '所有的线索终于连成了一条线...' },
      { id: 406, number: 6, title: '最后的审判', date: '2026-04-05', content: '法庭上的最后一刻，真相大白...' },
    ],
  },
  {
    id: 5,
    title: '咖啡店的一天',
    author: '尹素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20Korean%20manhwa%20cover%20illustration%20of%20a%20warm%20coffee%20shop%20interior%20with%20a%20barista%20smiling%2C%20slice%20of%20life%20style%2C%20soft%20warm%20beige%20and%20brown%20tones%2C%20comfortable%20atmosphere%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-05&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '在首尔延南洞的一条安静小巷里，有一家名为"一天"的咖啡店。店主智恩用一杯杯温暖的咖啡和点心，倾听着每个客人的故事。这里没有惊天动地的大事，只有平凡生活中的小小感动。',
    tags: ['治愈', '美食', '日常', '温暖'],
    rating: 8.9,
    views: 890000,
    status: '已完结',
    updateDate: '2026-06-30',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 501, number: 1, title: '开店第一天', date: '2026-01-10', content: '阳光正好，咖啡的香气弥漫在空气中...' },
      { id: 502, number: 2, title: '第一位客人', date: '2026-01-17', content: '推门进来的是一位满头白发的老人...' },
      { id: 503, number: 3, title: '雨天的访客', date: '2026-01-24', content: '暴雨中，一个浑身湿透的年轻人冲了进来...' },
      { id: 504, number: 4, title: '意外的重逢', date: '2026-01-31', content: '十年没见的老朋友，竟然在这里相遇...' },
      { id: 505, number: 5, title: '最后一杯咖啡', date: '2026-02-07', content: '咖啡店的故事，才刚刚开始...' },
    ],
  },
  {
    id: 6,
    title: '社内恋爱禁止令',
    author: '韩彩英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20manhwa%20cover%20illustration%20of%20two%20office%20workers%20trying%20to%20hide%20their%20relationship%2C%20romantic%20comedy%20style%2C%20bright%20cheerful%20colors%2C%20playful%20atmosphere%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-06&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '公司明文规定禁止办公室恋情，但偏偏人事部的新人组长和设计部的王牌设计师从第一天见面就擦出了火花。一边是严格的公司制度，一边是无法抑制的心动，两人的秘密恋爱充满了各种啼笑皆非的意外。',
    tags: ['办公室', '恋爱喜剧', '职场', '搞笑'],
    rating: 9.0,
    views: 1560000,
    status: '连载中',
    updateDate: '2026-08-01',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 601, number: 1, title: '新来的组长', date: '2026-04-01', content: '新人事组长上任第一天，就闹出了大笑话...' },
      { id: 602, number: 2, title: '电梯里的尴尬', date: '2026-04-08', content: '狭小的空间，只有两个人...' },
      { id: 603, number: 3, title: '团建的意外', date: '2026-04-15', content: '公司团建，两个人的秘密差点暴露...' },
      { id: 604, number: 4, title: '地下恋情', date: '2026-04-22', content: '正式确定关系后，问题才真正开始...' },
      { id: 605, number: 5, title: '差点被发现', date: '2026-04-29', content: '老板突然出现，两人的心跳同时停止...' },
    ],
  },
  {
    id: 7,
    title: '梨泰院之夜',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20Korean%20manhwa%20cover%20illustration%20of%20a%20trendy%20nightlife%20scene%20in%20Itaewon%20with%20neon%20lights%2C%20urban%20romance%20style%2C%20vibrant%20city%20atmosphere%2C%20warm%20neon%20glow%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-07&orientation=portrait',
    category: '都市',
    categorySlug: 'urban',
    description: '梨泰院的夜晚从不缺少故事。调酒师泰俊、厨师美英、街头艺人贤秀，三个年轻人的命运在梨泰院的霓虹灯下交织。爱情、梦想、友情，在这座不夜城里，每个人都在追寻属于自己的光芒。',
    tags: ['都市', '励志', '爱情', '青春'],
    rating: 8.8,
    views: 720000,
    status: '连载中',
    updateDate: '2026-07-28',
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: 701, number: 1, title: '酒吧的常客', date: '2026-06-01', content: '她每周五都会准时出现在吧台前...' },
      { id: 702, number: 2, title: '厨房里的秘密', date: '2026-06-08', content: '他在后厨藏了一个不为人知的梦想...' },
      { id: 703, number: 3, title: '街头的声音', date: '2026-06-15', content: '他的歌声总能吸引路人停下脚步...' },
    ],
  },
  {
    id: 8,
    title: '花都秘录',
    author: '宋智孝',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20historical%20manhwa%20cover%20illustration%20of%20a%20noblewoman%20in%20traditional%20hanbok%20in%20a%20palace%20garden%2C%20historical%20romance%20style%2C%20elegant%20soft%20colors%2C%20traditional%20Korean%20aesthetic%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-08&orientation=portrait',
    category: '古风',
    categorySlug: 'historical',
    description: '朝鲜王朝时期，一位来自现代的灵魂意外穿越到宫中。凭借现代知识和过人智慧，她在尔虞我诈的宫廷中步步为营。但她不知道的是，她的到来早已被记载在古老的秘录之中，一切似乎都是命中注定。',
    tags: ['穿越', '宫廷', '权谋', '爱情'],
    rating: 9.3,
    views: 2100000,
    status: '连载中',
    updateDate: '2026-08-04',
    isHot: true,
    isNew: true,
    isRecommended: true,
    chapters: [
      { id: 801, number: 1, title: '穿越', date: '2026-07-15', content: '醒来时，周围的一切都变了...' },
      { id: 802, number: 2, title: '宫中的第一天', date: '2026-07-18', content: '每个宫女的眼中都藏着故事...' },
      { id: 803, number: 3, title: '密函', date: '2026-07-22', content: '一封密函改变了她所有的计划...' },
      { id: 804, number: 4, title: '世子殿下', date: '2026-07-26', content: '第一次见到世子，她就知道这个人不简单...' },
      { id: 805, number: 5, title: '花都秘录的预言', date: '2026-08-01', content: '那本古老的秘录上，赫然写着她的名字...' },
    ],
  },
  {
    id: 9,
    title: '心跳加速',
    author: '安孝燮',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20manhwa%20cover%20illustration%20of%20a%20high%20school%20couple%20sharing%20earphones%20on%20a%20sunny%20afternoon%2C%20youth%20romance%20style%2C%20soft%20pastel%20pink%20and%20peach%20tones%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-09&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '高二的夏天，转学生金多美坐到了体育特长生韩俊昊的旁边。一个是安静内向的学霸，一个是阳光开朗的体育健将。两个截然不同的人，在一场校园运动会中产生了奇妙的化学反应。',
    tags: ['校园', '纯爱', '青春', '甜蜜'],
    rating: 8.7,
    views: 670000,
    status: '已完结',
    updateDate: '2026-06-15',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 901, number: 1, title: '转学生', date: '2026-04-01', content: '新学期的第一天，班里来了一个转学生...' },
      { id: 902, number: 2, title: '同桌的你', date: '2026-04-08', content: '座位安排下来的时候，全班都惊呆了...' },
      { id: 903, number: 3, title: '运动会', date: '2026-04-15', content: '运动会那天，一切都开始改变...' },
      { id: 904, number: 4, title: '天台上的告白', date: '2026-04-22', content: '夕阳下，天台上的风很温柔...' },
    ],
  },
  {
    id: 10,
    title: '无限职业玩家',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20cover%20illustration%20of%20a%20game%20character%20with%20multiple%20weapons%20and%20skills%20displayed%2C%20action%20fantasy%20style%2C%20vibrant%20energy%20effects%2C%20epic%20atmosphere%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-10&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    description: '游戏排名第一的职业玩家李贤宇，在一次意外中穿越到了游戏世界。在这里，他的所有游戏技能都变成了真实的战斗能力。为了回到现实世界，他必须打通所有关卡，而每一关的BOSS都比上一关更加强大。',
    tags: ['游戏', '穿越', '升级', '战斗'],
    rating: 9.0,
    views: 1780000,
    status: '连载中',
    updateDate: '2026-08-03',
    isHot: false,
    isNew: true,
    isRecommended: true,
    chapters: [
      { id: 1001, number: 1, title: '最后的副本', date: '2026-07-10', content: '击败最终BOSS的瞬间，屏幕突然变白...' },
      { id: 1002, number: 2, title: '新世界', date: '2026-07-14', content: '眼前的一切都如此熟悉又陌生...' },
      { id: 1003, number: 3, title: '等级一的新手', date: '2026-07-18', content: '从零开始，但我的技能面板说明了一切...' },
      { id: 1004, number: 4, title: '第一个副本', date: '2026-07-22', content: '新手村的第一个副本，比我想象的难得多...' },
    ],
  },
  {
    id: 11,
    title: '月下幻境',
    author: '李敏镐',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mystical%20Korean%20manhwa%20cover%20illustration%20of%20a%20moonlit%20fantasy%20landscape%20with%20a%20mysterious%20figure%20floating%2C%20ethereal%20fantasy%20style%2C%20silver%20and%20lavender%20tones%2C%20dreamlike%20atmosphere%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-11&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '每当月圆之夜，少女素妍就能进入一个名为"月下幻境"的异世界。在那里，她遇到了被封印千年的精灵王子。为了解开封印，两人踏上了寻找七颗月之泪的冒险旅程。',
    tags: ['异世界', '精灵', '冒险', '浪漫'],
    rating: 8.6,
    views: 540000,
    status: '连载中',
    updateDate: '2026-07-25',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 1101, number: 1, title: '月圆之夜', date: '2026-06-01', content: '月光照进窗户的那一刻，她消失了...' },
      { id: 1102, number: 2, title: '封印之地', date: '2026-06-08', content: '古老的封印之下，沉睡着一位精灵...' },
      { id: 1103, number: 3, title: '第一颗月之泪', date: '2026-06-15', content: '月之泪隐藏在森林的最深处...' },
    ],
  },
  {
    id: 12,
    title: '失踪的画家',
    author: '朴宝剑',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20cover%20illustration%20of%20an%20empty%20art%20studio%20with%20an%20unfinished%20painting%20on%20an%20easel%2C%20psychological%20thriller%20style%2C%20moody%20atmospheric%20lighting%2C%20dark%20teal%20and%20grey%20tones%2C%20clean%20simple%20background%2C%20Korean%20webtoon%20art%20style%2C%20professional%20digital%20illustration&width=600&height=840&seq=comic-cover-12&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '知名画家金允浩在完成最后一幅画作后神秘失踪，留下的只有一幅未完成的画和一个密码日记本。他的女儿为了寻找父亲的下落，开始解读日记中的密码，却一步步揭开了一个被尘封二十年的惊人秘密。',
    tags: ['推理', '艺术', '家族秘密', '心理'],
    rating: 9.1,
    views: 1340000,
    status: '已完结',
    updateDate: '2026-07-10',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 1201, number: 1, title: '画室之谜', date: '2026-05-01', content: '画室里还残留着松节油的味道...' },
      { id: 1202, number: 2, title: '密码日记', date: '2026-05-08', content: '日记的第一页写着"给最爱的女儿"...' },
      { id: 1203, number: 3, title: '第一幅画', date: '2026-05-15', content: '那幅画里隐藏着一个坐标...' },
      { id: 1204, number: 4, title: '二十年前的真相', date: '2026-05-22', content: '真相远比想象中更加令人震惊...' },
      { id: 1205, number: 5, title: '最后的画作', date: '2026-05-29', content: '那幅未完成的画，终于展露了全貌...' },
    ],
  },
];

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getHotComics(): Comic[] {
  return comics.filter((c) => c.isHot);
}

export function getNewComics(): Comic[] {
  return comics.filter((c) => c.isNew);
}

export function getRecommendedComics(): Comic[] {
  return comics.filter((c) => c.isRecommended);
}

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}